import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc2008',
    ecrans: ['00-2'],
    params: ['id']
});
